var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRoundedGradientEnvelope = function SvgRoundedGradientEnvelope(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1562 30H9.84375C4.41591 30 0 26.0026 0 21.0891V8.91089C0 3.99743 4.41591 0 9.84375 0H32.1562C37.5841 0 42 3.99743 42 8.91089V21.0891C42 26.0026 37.5841 30 32.1562 30ZM9.84375 2.9703C6.22519 2.9703 3.28125 5.63525 3.28125 8.91089V21.0891C3.28125 24.3647 6.22519 27.0297 9.84375 27.0297H32.1562C35.7748 27.0297 38.7187 24.3647 38.7187 21.0891V8.91089C38.7187 5.63525 35.7748 2.9703 32.1562 2.9703H9.84375ZM27.0117 17.6292L35.1209 12.0218C35.841 11.5239 35.9788 10.5919 35.4288 9.9401C34.8787 9.28827 33.8492 9.16351 33.1291 9.66141L25.0209 15.2681C22.6796 16.8846 19.41 16.8858 17.0671 15.2722L9.2101 9.74332C8.49471 9.23985 7.4639 9.35681 6.9079 10.0044C6.35181 10.652 6.48092 11.585 7.19632 12.0884L15.0594 17.6215C15.0634 17.6243 15.0674 17.6271 15.0714 17.6298C16.8288 18.8432 18.9346 19.4498 21.0408 19.4498C23.147 19.4498 25.2537 18.8428 27.0117 17.6292V17.6292Z",
    fill: "url(#paint0_linear_3751_59937)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3751_59937",
    x1: 42.7875,
    y1: 21.75,
    x2: 15.4337,
    y2: -6.52544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3559FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36B2FA"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRoundedGradientEnvelope);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rounded-gradient-envelope.8f1905bcab468b1b8a738f815bd5155d.svg";